'use strict';var _dec,_desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const Group=require('../../../../../dist-es6/shared/domain/group');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const SocketResponse=require('../../../../../dist-es6/client/dtos/socketResponse');let

EditGroupModalController=(_dec=













































HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=class EditGroupModalController extends BaseController{static get $inject(){return['$modalInstance','resolvedParameters','uncaughtErrorHandler','$modal','uiCommandFactory','socketService','groupUpdateErrorHandlingService']}constructor($modalInstance,resolvedParameters,uncaughtErrorHandler,$modal,uiCommandFactory,socketService,groupUpdateErrorHandlingService){super(uncaughtErrorHandler);this._$modalInstance=$modalInstance;this._$modal=$modal;this._group=resolvedParameters.group;this._updatedName=resolvedParameters.group.name;this._onGroupSaved=resolvedParameters.onGroupSaved;this._onGroupDeleted=resolvedParameters.onGroupDeleted;this._socketService=socketService;this._groupUpdateErrorHandlingService=groupUpdateErrorHandlingService;this._saveGroupCommand=uiCommandFactory.makeForModal($modalInstance,()=>this._saveGroup());this._saveErrors=[]}get saveGroupCommand(){return this._saveGroupCommand}get saveErrors(){return this._saveErrors}deleteGroup(){this._$modalInstance.dismiss();let modalInstance=this._$modal.open({templateUrl:'/templates/features/groups/modals/deleteGroupModalView',controller:'DeleteGroupModalController as controller',resolve:{resolvedParameters:()=>{return{group:this._group,onGroupDeleted:this._onGroupDeleted}}}})}
async _saveGroup(){
this._saveErrors=[];

const response=await this._socketService.sendAndWaitForResponse('RenameGroup',{groupId:this._group.id,name:this.updatedName});

if(!SocketResponse.succeeded(response)){
if(response.status==='HttpError'&&response.body.httpStatus===422){
const newNameLength=this.updatedName.trim().length;
if(newNameLength<Group.MinNameLength||newNameLength>Group.MaxNameLength){
this._saveErrors=[`Name must contain between ${Group.MinNameLength} and ${Group.MaxNameLength} characters.`];
return ModalSubmissionResult.KeepOpen;
}

this._saveErrors=response.body.errors;
return ModalSubmissionResult.KeepOpen;
}

this._groupUpdateErrorHandlingService.handle(response);
}

await this._onGroupSaved(this._group.id);

return ModalSubmissionResult.Close();
}

onCancel(){
this._$modalInstance.dismiss();
}

get updatedName(){
return this._updatedName||'';
}

set updatedName(updatedName){
this._updatedName=updatedName;
}},(_applyDecoratedDescriptor(_class.prototype,'_saveGroup',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_saveGroup'),_class.prototype)),_class));


module.exports=EditGroupModalController;
//# sourceMappingURL=editGroupModalController.js.map
